'use strict';

/**
 * Returns the object wrapper for the given object if the given object
 * is a primitive value, or simply returns the object otherwise.
 * Returns null for objects with no wrappers.
 *
 * @param  {*} obj
 * @return {Object|null}
 */
module.exports = function getObjectWrapper (obj) {
  if (obj === null || obj === undefined) {
    return null;
  } else if (typeof obj === 'object') {
    return obj;
  } else {
    return Object(obj);
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/getObjectWrapper.js